import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import CustomFieldList from "go-component/components/CustomField/CustomFieldList";
import { selectOrganization } from "go-security/services/organizations/selectors";

const OrganizationSettingsCustomFieldsIndexPage = (props: RouteComponentProps) => {
	const organization = useSelector(selectOrganization);
	return <CustomFieldList organization_name={organization.name ? organization.name : ""} routeProps={props} />;
};

export default OrganizationSettingsCustomFieldsIndexPage;
